import React from 'react';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';

import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';

import {
    EstimatedTradeCostComparisonColumn,
    estimatedTradeCostComparisonColumnsDefinitions,
} from './columns';
import { getInitialEstimatedTradeCostComparisonConfigState } from 'widgets/estimatedTradeCost/widget-comparison/store/EstimatedTradeCostComparisonConfigState';
import { useEstimatedTradeCostComparisonWidgetConfigSlice } from 'widgets/estimatedTradeCost/widget-comparison/store/configslice';

export default function EstimatedTradeCostComparisonColumnPicker() {
    const {
        config: { visibleColumns },
    } = useEstimatedTradeCostComparisonWidgetConfigSlice();

    const allPickableItems: PickableItem<EstimatedTradeCostComparisonColumn>[] =
        estimatedTradeCostComparisonColumnsDefinitions.map((column) => ({
            value: column.field as EstimatedTradeCostComparisonColumn,
            name: column.name || column.field!,
            tag: column.tag,
            desc: column.headerTooltip ?? column.name,
        }));

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (
        cols: EstimatedTradeCostComparisonColumn[]
    ) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                getInitialEstimatedTradeCostComparisonConfigState()
                    .visibleColumns
            }
            allItems={allPickableItems}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
